import {Camelize} from '@malt/types-utils';
import upperCase from 'lodash/upperCase';

function getCookie(cname: string): string {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function lazyCapitalize(value: string): string {
    const [firstLetter, ...rest] = value.split('');
    return [upperCase(firstLetter), ...rest].join('');
}

function camelize(value: string): string {
    if (/.+[_-].+/.test(value)) {
        const [firstUnder, ...restUnder] = value.split('_');
        const reconsValue = [firstUnder, ...restUnder.map((m) => lazyCapitalize(m))].join('');
        const [firstHyphen, ...restHyphen] = reconsValue.split('-');
        return [firstHyphen, ...restHyphen.map((m) => lazyCapitalize(m))].join('');
    }
    return value;
}

/**
 * Return cookies as static values for specified keys
 * The values are not reactives
 *
 * ### ⚠️ Only use inside `setup` function or in a composable
 *
 * @param keys an array of cookie keys to retrieve
 *
 * @exemple
 *
 * ```ts
 *  const {trackerId, XSRFTOKEN} = useCookies(['tracker_id', 'XSRF-TOKEN']);
 * ```
 */
export function useCookies<T extends string[]>(keys: [...T]): Record<Camelize<T[number]>, string> {
    const cookies = Object.fromEntries(keys.map((key) => [camelize(key), getCookie(key)]));
    return cookies as Record<Camelize<T[number]>, string>;
}
